import { AWS_AUTH_TYPES, DEFAULT_KINESIS_LOG_TYPE } from "./constants";
export const toAWSRequest = (formData, options) => {
  const {
    awsAuthenticationType,
    awsAssumeRoleARN,
    awsExternalId,
    awsAccessKey,
    awsSecretKey,
    awsEndpointCloudWatch,
    awsEndpointIAM,
    awsEndpointDynamoDB,
    awsEndpointKinesis,
    key,
    secret
  } = formData;
  return {
    ...(awsAuthenticationType == null ? void 0 : awsAuthenticationType.value) === AWS_AUTH_TYPES.keysecret ? {
      aws_access_key_id: awsAccessKey == null ? void 0 : awsAccessKey.value,
      aws_secret_access_key: awsSecretKey == null ? void 0 : awsSecretKey.value
    } : {
      aws_access_key_id: key,
      aws_secret_access_key: secret
    },
    assume_role_arn: awsAssumeRoleARN == null ? void 0 : awsAssumeRoleARN.value,
    aws_external_id: awsExternalId == null ? void 0 : awsExternalId.value,
    cloudwatch_endpoint: awsEndpointCloudWatch == null ? void 0 : awsEndpointCloudWatch.value,
    dynamodb_endpoint: awsEndpointDynamoDB == null ? void 0 : awsEndpointDynamoDB.value,
    iam_endpoint: awsEndpointIAM == null ? void 0 : awsEndpointIAM.value,
    kinesis_endpoint: awsEndpointKinesis == null ? void 0 : awsEndpointKinesis.value,
    ...options
  };
};
export const toGenericInputCreateRequest = ({
  awsAuthenticationType,
  awsCloudWatchAddFlowLogPrefix = { value: void 0 },
  awsCloudWatchStoreFullMessage = { value: void 0 },
  awsAssumeRoleARN = { value: void 0 },
  awsExternalId = { value: void 0 },
  awsAccessKey = { value: void 0 },
  awsCloudWatchAwsRegion,
  awsCloudWatchBatchSize,
  awsEndpointCloudWatch = { value: void 0 },
  awsCloudWatchKinesisInputType = { value: DEFAULT_KINESIS_LOG_TYPE },
  awsCloudWatchKinesisStream,
  awsCloudWatchName,
  awsCloudWatchThrottleEnabled = { value: void 0 },
  awsEndpointDynamoDB = { value: void 0 },
  awsEndpointIAM = { value: void 0 },
  awsEndpointKinesis = { value: void 0 },
  awsSecretKey,
  key,
  secret,
  overrideSource
}) => ({
  type: "org.graylog.integrations.aws.inputs.AWSInput",
  title: awsCloudWatchName.value,
  configuration: {
    ...(awsAuthenticationType == null ? void 0 : awsAuthenticationType.value) === AWS_AUTH_TYPES.keysecret ? {
      aws_access_key: awsAccessKey == null ? void 0 : awsAccessKey.value,
      aws_secret_key: awsSecretKey == null ? void 0 : awsSecretKey.value
    } : {
      aws_access_key: key,
      aws_secret_key: secret
    },
    aws_message_type: awsCloudWatchKinesisInputType.value,
    throttling_allowed: !!awsCloudWatchThrottleEnabled.value,
    aws_flow_log_prefix: !!awsCloudWatchAddFlowLogPrefix.value,
    store_full_message: !!(awsCloudWatchStoreFullMessage == null ? void 0 : awsCloudWatchStoreFullMessage.value),
    aws_region: awsCloudWatchAwsRegion.value,
    aws_assume_role_arn: awsAssumeRoleARN == null ? void 0 : awsAssumeRoleARN.value,
    aws_external_id: awsExternalId == null ? void 0 : awsExternalId.value,
    cloudwatch_endpoint: awsEndpointCloudWatch == null ? void 0 : awsEndpointCloudWatch.value,
    dynamodb_endpoint: awsEndpointDynamoDB == null ? void 0 : awsEndpointDynamoDB.value,
    iam_endpoint: awsEndpointIAM == null ? void 0 : awsEndpointIAM.value,
    kinesis_endpoint: awsEndpointKinesis == null ? void 0 : awsEndpointKinesis.value,
    kinesis_stream_name: awsCloudWatchKinesisStream.value,
    kinesis_record_batch_size: Number(awsCloudWatchBatchSize.value || awsCloudWatchBatchSize.defaultValue),
    override_source: overrideSource == null ? void 0 : overrideSource.value
  }
});
